// DecorativeSection: sezione con sfondo decorativo
export default function DecorativeSection({ children, className = "", overlay = 70 }) {
  return (
    <div 
      className={`py-16 md:py-24 relative ${className}`}
      style={{
        backgroundImage: 'url(/decorazionebg.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '400px'
      }}
    >
      <div 
        className="absolute inset-0 bg-white"
        style={{ opacity: overlay / 100 }}
      ></div>
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
}
